import { tickerItems } from "@/mocks/home";

const statusPills = [
  { icon: "ri-checkbox-circle-fill", label: "主站畅通", tone: "online" },
  { icon: "ri-route-line", label: "备用线 2 条", tone: "normal" },
  { icon: "ri-global-line", label: "镜像线 1 条", tone: "normal" },
  { icon: "ri-time-line", label: "更新于今天 18:40", tone: "muted" },
];

export default function HeroSection() {
  return (
    <section id="top" className="relative">
      <div className="relative w-full h-[560px] md:h-[660px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20crimson%20and%20amber%20smoke%20texture%2C%20dramatic%20spotlight%20beam%20over%20deep%20espresso%20background%2C%20cinematic%20moody%20atmosphere%2C%20no%20people%2C%20no%20text%2C%20editorial%20poster%20style%2C%20high%20contrast%20negative%20space&width=1600&height=900&seq=hl-hero-bg-01&orientation=landscape"
          alt="黑料入口主视觉背景"
          title="黑料入口 备用入口 防走失"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/90" />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/60 via-transparent to-accent-950/40" />

        <div className="relative z-10 w-full h-full flex items-center">
          <div className="w-full px-4 md:px-8">
            <div className="max-w-4xl">
              <div className="hl-rise inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-background-50/25 bg-background-50/10 backdrop-blur-sm">
                <span className="w-2 h-2 rounded-full bg-accent-400" />
                <span className="text-xs md:text-sm font-label tracking-wider text-background-100">
                  防走失 · 防屏蔽 · 防失联
                </span>
              </div>

              <h1 className="hl-rise mt-6 font-heading font-black text-background-50 leading-[1.08] text-5xl md:text-7xl">
                黑料入口
                <span className="block mt-2 text-2xl md:text-4xl text-accent-300">
                  备用入口 · 防走失新地址
                </span>
              </h1>

              <p className="hl-rise mt-6 max-w-2xl text-background-200 text-base md:text-lg leading-relaxed">
                打不开别慌。这里整理好黑料入口备用与防走失的新地址，
                防屏蔽、防失联，收藏这一页，随时换个入口继续吃瓜看爆料。
              </p>

              <div className="hl-rise mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href="#entries"
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-medium transition-colors shadow-none whitespace-nowrap"
                >
                  <i className="ri-links-line text-lg" />
                  立即进入主站
                </a>
                <a
                  href="#entries"
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-md border border-background-50/35 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 font-label font-medium transition-colors whitespace-nowrap"
                >
                  <i className="ri-route-line text-lg" />
                  查看全部备用入口
                </a>
              </div>

              <div className="hl-rise mt-10 flex flex-wrap items-center gap-2.5">
                {statusPills.map((pill) => (
                  <span
                    key={pill.label}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-background-50/10 border border-background-50/15 text-background-200 text-xs md:text-sm font-label"
                  >
                    <i
                      className={`${pill.icon} ${
                        pill.tone === "online"
                          ? "text-accent-400"
                          : pill.tone === "normal"
                            ? "text-background-100"
                            : "text-background-300"
                      }`}
                    />
                    {pill.label}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full bg-foreground-950 border-y border-background-50/10 overflow-hidden">
        <div className="flex items-center">
          <div className="hidden md:flex items-center gap-2 px-5 py-3 bg-primary-500 text-background-50 shrink-0">
            <i className="ri-megaphone-line" />
            <span className="text-sm font-label font-medium whitespace-nowrap">站内广播</span>
          </div>
          <div className="relative flex-1 overflow-hidden py-3">
            <div className="hl-marquee-track flex w-max items-center gap-10 px-6">
              {[...tickerItems, ...tickerItems].map((item, index) => (
                <span
                  key={`${item}-${index}`}
                  className="flex items-center gap-3 text-sm text-background-200 font-label whitespace-nowrap"
                >
                  <i className="ri-circle-fill text-[7px] text-accent-400" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}